@if (appFacadeService.isContractSelectable(contract.contractId) | async) {
<div class="checkbox">
    <por-base-checkbox
        #check
        [isChecked]="(appFacadeService.isContractAvailableInState(contract.contractId) | async) || params.value"
        (checkboxChange)="onCheckboxChange($event)"
        [showLabel]="false"></por-base-checkbox>
</div>
}
